let appointmentsConfig = type =>
  ({
    client: {
      header: [
        { prop: "Нотариус", lg: 6 },
        { prop: "Дата приёма", lg: 3 },
        { prop: "Адрес нотариальной конторы", lg: 5 },
        { prop: "Статус заявки", lg: 4 },
        { prop: "Номер заявки", lg: 3 }
      ],
      getBody: data => ({
        notary: { type: "user", prop: data.notary.getFullName(), lg: 6 },
        date: { type: "text", prop: data.getDateTime(), lg: 3 },
        address: { type: "text", prop: data.notary.getFullAddress(), lg: 5 },
        status: { type: "status", prop: data.getStatusConfig(), lg: 4 },
        num: { type: "text", prop: data.book_id, lg: 4 },
        link: { type: "link", prop: data.code, lg: 2 }
      })
    },
    notary: {
      header: [
        { prop: "Время", lg: 3 },
        { prop: "Клиент", lg: 5 },
        { prop: "Телефон", lg: 4 },
        { prop: "Статус заявки", lg: 5 },
        { prop: "Номер заявки", lg: 4 }
      ],
      getBody: data => ({
        time: { type: "text", prop: data.getTime(), lg: 3 },
        client: { type: "text", prop: data.client.fio, lg: 5 },
        phone: { type: "text", prop: data.client.phone, lg: 4 },
        status: { type: "status", prop: data.getStatusConfig(), lg: 5 },
        num: { type: "text", prop: data.id, lg: 2 },
        link: { type: "link", prop: data.id, lg: 2 }
      })
    }
  }[type]);

export default appointmentsConfig;
